import * as types from '../mutation-types';
import {unionState} from '../union-state'
import ls from '../../settings/localStorageExtension'
let rotatedCurrentFinancialFileId;

const state = {
	financial_files: [],
	current_financial_file: {}
};

const actions = {
	fetchAll({ commit }, { fromDate, toDate, archiveStatus, fiscalYear, companyName, status }) {
		return window.axios.get('FinancialFiles', {
			params: {
				fromDate,
				toDate,
				archiveStatus,
				fiscalYear,
				companyName,
				status
			}
		}).then(response => {
			commit(types.STORE_FINANCIAL_FILES, response.data)
		})
	},
	create({ commit }, {company_name, year_name, start_date, end_date, default_currency_id, default_language}) {
		return window.axios.post(`FinancialFiles`, {
			company_name, 
            year_name, 
            start_date, 
            end_date, 
			default_currency_id,
			default_language
		}).then(response => {
			commit(types.STORE_ONE_FINANCIAL_FILE, response.data)
			return response.data;
		});
	},
	update({ commit }, { id, company_name, year_name, start_date, end_date, default_currency_id, default_language }) {
		return window.axios.put(`FinancialFiles/${id}`, {
			company_name, 
            year_name, 
            start_date, 
            end_date, 
			default_currency_id,
			default_language
		})
		.then(response => {
			commit(types.STORE_ONE_FINANCIAL_FILE, response.data)
			return response.data;
		});
	},
	uploadLogo(vuexContext, { id, file }) {
		let formData = new FormData();
		formData.append('file', file);

		return window.axios.put(`FinancialFiles/${id}/UploadLogo`, formData, {
			headers: { 'Content-Type': 'multipart/form-data' }
		})
		.then(response => {
			return response.data;
		});
	},
	fetchFinancialFile({ commit }, id) {
		return window.axios.get(`FinancialFiles/${id}`,
		).then(response => {
			commit(types.STORE_ONE_FINANCIAL_FILE, response.data)
			return response.data;
		})
	},
	delete({ commit }, { id }) {
		return window.axios.delete(`FinancialFiles/${id}`).then(response => {
			commit(types.STORE_ONE_FINANCIAL_FILE, response.data)
		});
	},

	updateArchive(vuexContext, { id, isArchive }) {
		const action = isArchive ? 'archive' : 'retrieve';
		return axios.put(`/financialFiles/${id}/${action}`);
	},

	updatePermissions(vuexContext, { id, permissions }) {
		return window.axios.put(`Users/FinancialFile/${id}/Permissions`, {permissions})
		.then(response => {
			return response.data;
		});
	},
	fetchPermissions(vuexContext, id) {
		return window.axios.get(`Users/FinancialFile/${id}/Permissions`)
		.then(response => {
			return response.data;
		});
	},

	lockValidate(vuexContext, { financialFileId }) {
		return window.axios.get(`FinancialFiles/${financialFileId}/Lock/Validate`)
		.then((response) => {
			return response.data;
		})
	},

	lock(vuexContext, { financialFileId }) {
		return window.axios.post(`FinancialFiles/${financialFileId}/Lock`)
	},

	unlock(vuexContext, { financialFileId }) {
		return window.axios.post(`FinancialFiles/${financialFileId}/Unlock`)
	},
	
	rotate(vuexContext, { financialFileId, rotated_financial_file_dto, open_inventory_account, with_accounts, with_materials }) {
		return window.axios.post(`FinancialFiles/${financialFileId}/Rotate`, {
			rotated_financial_file_dto, open_inventory_account, with_accounts, with_materials,ignore_negative_materials_count: true
		})
		.then((response) => {
			return response.data;
		})

		/*
		rotated_financial_file_dto: {
			name
			year
			start_date
			end_date
			default_language
		},
		open_inventory_account: {
			parent_id
			name
			inner_no
		},
		*/
	},

	rotateWithStep(vuexContext, {
		step,
		// step 1 data
		financialFileId, name, year, startDate, endDate, defaultLanguage,
		// step 2 data
		createOpeningInventoryAccount, accountName, parentAccountId, innerAccountingNo,
		// step 4 data
		ignoreNegativeItemsCount, isDeprecated
	}) {
		let requestURL = `/FinancialFiles/${financialFileId}/Rotate`;
		let bodyData;
		let params;
		switch (step) {
			case 1: {
				requestURL+= '/CreateNewFinancialFile';
				bodyData = {
					name,
					year,
					start_date: startDate,
					end_date: endDate,
					default_language: defaultLanguage
				};
				params = {};
				break; 
			}
			case 2: {
				requestURL+= '/MoveAccountsTree';
				bodyData = {
					name: accountName,
					parent_account_id: parentAccountId,
					inner_accounting_no: innerAccountingNo
				};
				params = { createOpeningInventoryAccount };
				break;
			} 
			case 3: {
				requestURL+= '/MoveCustomStatements';
				bodyData = {};
				params = {};
				break;
			} 
			case 4: {
				requestURL+= '/MoveItemTrees';
				bodyData = {};
				params = { ignoreNegativeItemsCount, isDeprecated };
				break;
			}
			case 5: {
				requestURL+= '/CreateOpeningAccountingBond';
				bodyData = {};
				params = {};
				break;
			}
			case 6: {
				requestURL+= '/CreateOpeningItemsJournal';
				bodyData = {};
				params = {};
				break;
			}
			case 7: {
				requestURL+= '/AddAccessPermissions';
				bodyData = {};
				params = {};
				break;
			}
		}
		return window.axios.post(requestURL, bodyData, { params }).then(({ data }) => {
			if (step === 1) {
				rotatedCurrentFinancialFileId = data;
				return rotatedCurrentFinancialFileId;
			} else {
				return rotatedCurrentFinancialFileId;
			}
		});
	},

	fetchRotateProgress(vuexContext, { financialFileId, rotateFileId }) {
		return window.axios.get(`/FinancialFiles/${financialFileId}/Rotate/Progress/${rotateFileId}`)
			.then(({ data }) => {
				rotatedCurrentFinancialFileId = rotateFileId;

				const status = {
					invoked: 1,
					completed: 2,
					failed: 3,
					deprecated: 4
				}

				let stepsOrder = [
					'CreateNewFinancialFile',
					'MoveAccountsTree',
					'MoveCustomStatements',
					'MoveItemTrees',
					'CreateOpeningAccountingBond',
					'CreateOpeningItemsJournal',
					'AddAccessPermissions',
				];

				const orderedStepsProgress = data.sort((a, b) => {
					const indexA = stepsOrder.indexOf(a.op_name);
					const indexB = stepsOrder.indexOf(b.op_name);
					if (indexA > indexB) return 1;
					else if (indexA < indexB) return -1;
					else return 0;
				})

				const latestSuccessOp = orderedStepsProgress.reverse().find(c => c.op_status === status.completed);
				const latestInvokedOp = orderedStepsProgress.reverse().find(c => c.op_status === status.invoked);
				const deprecatedOp = orderedStepsProgress.reverse().find(c => c.op_name === 'MoveItemTrees' && c.op_status === status.deprecated);

				if (!latestSuccessOp) {
					return {
						step: 0,
						invokedStep: null,
						isMoveItemsTreeDeprecated: false,
						op: null
					}
				}

				return {
					step: stepsOrder.indexOf(latestSuccessOp.op_name) + 1,
					invokedStep: latestInvokedOp ? stepsOrder.indexOf(latestInvokedOp.op_name) + 1 : null,
					isMoveItemsTreeDeprecated: Boolean(deprecatedOp),
					op: latestSuccessOp
				}
			})
	}
}

const mutations = {
	[types.STORE_FINANCIAL_FILES](state, financial_files) {
		state.financial_files = financial_files;
	},
	[types.STORE_ONE_FINANCIAL_FILE](state, file) {
        state.financial_files = unionState(state.financial_files, [file]);
		if(file.id == ls.getLocalFinancialFileId())
			state.current_financial_file = file
	},
	[types.DELETE_FINANCIAL_FILE](state, file) {
        state.financial_files = unionState(state.financial_files, [file]);
	},
}

const getters = {
	getFinancialFileById: state => id => state.financial_files.find(c => c.id === id)
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}

